import { render, staticRenderFns } from "./tempMomentsComponent.vue?vue&type=template&id=487b7ad9&scoped=true"
import script from "./tempMomentsComponent.vue?vue&type=script&lang=js"
export * from "./tempMomentsComponent.vue?vue&type=script&lang=js"
import style0 from "./tempMomentsComponent.vue?vue&type=style&index=0&id=487b7ad9&prod&scoped=true&lang=css"
import style1 from "./tempMomentsComponent.vue?vue&type=style&index=1&id=487b7ad9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b7ad9",
  null
  
)

export default component.exports